(() => {
  if (typeof FormData === 'undefined' && typeof window !== 'undefined') {
    window.FormData = () => { };
  }
})();
